import { render, staticRenderFns } from "./ProductListStokResim.vue?vue&type=template&id=32f5e380&"
import script from "./ProductListStokResim.vue?vue&type=script&lang=js&"
export * from "./ProductListStokResim.vue?vue&type=script&lang=js&"
import style0 from "./ProductListStokResim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports